/** localStorage key for the most-recently-used mini-apps list */
export const MRU_KEY = 'terra-miniapps-recent';
